import { useMemo } from "react";

import { projectHookPreselect, userHookPreselect } from "app/contexts/AddonStateContext/const";
import { useNoTouchPurchaseContext } from "app/contexts/NoTouchPurchaseContext/NoTouchPurchaseContext";
import { AddonBanner } from "app/pages/activation/components/AddonBanners/Banner/Banner";
import { Icon } from "app/pages/activation/components/AddonBanners/Banner/Banner.styles";
import { ROCKET_ICON } from "app/pages/activation/components/AddonBanners/constants";
import { ProjectsCtaBannerDict } from "app/pages/activation/components/AddonBanners/ProjectsCtaBanner/TopBannerType";
import { useProjectsCtaBanner } from "app/pages/activation/components/AddonBanners/ProjectsCtaBanner/useProjectsCtaBanner";
import { activationTracking } from "app/pages/activation/services/tracking";
import { AssetsService } from "app/services/AssetsService";
import { allTrackers } from "app/services/track/track";

const translationSuffixMap = {
    [ProjectsCtaBannerDict.ProjectsCta]: "AdditionalProjects",
    [ProjectsCtaBannerDict.UsersCta]: "AdditionalUsers",
};

const packageIdsMap = {
    [ProjectsCtaBannerDict.ProjectsCta]: projectHookPreselect,
    [ProjectsCtaBannerDict.UsersCta]: userHookPreselect,
};

export const ProjectsCtaBanner = () => {
    const { bannerType, onClose } = useProjectsCtaBanner();
    const { handlePurchaseAddonClick } = useNoTouchPurchaseContext();

    const { trackUserClickTopBannerCTA, trackUserClickTopBannerClose } = activationTracking.home;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    // @ts-ignore Property 'None' does not exist on type '{ ProjectsCta: "AdditionalProjectsDynamic"; UsersCta: "AdditionalUsersDynamic"; }'
    const packageId: string = packageIdsMap[bannerType];

    const onCtaButtonClick = () => {
        if (bannerType === ProjectsCtaBannerDict.UsersCta) {
            trackUserClickTopBannerCTA();
        } else if (bannerType === ProjectsCtaBannerDict.ProjectsCta) {
            allTrackers.dispatchTrackEvent("internal link", "click", "homepage/upper banner");
        }

        // @ts-ignore Property 'None' does not exist on type '{ ProjectsCta: "AdditionalProjectsDynamic"; UsersCta: "AdditionalUsersDynamic"; }'
        handlePurchaseAddonClick(packageId);
    };

    const onCloseClickWithTracking = () => {
        trackUserClickTopBannerClose();
        onClose();
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    // @ts-ignore Property 'None' does not exist on type '{ ProjectsCta: string; UsersCta: string; }'.
    const translationKeySuffix = translationSuffixMap[bannerType];

    const bannerDescription = useMemo(
        () => `home.page.topBanner.description.${translationKeySuffix}`,
        [translationKeySuffix],
    );

    const bannerCTA = useMemo(() => `home.page.topBanner.ctaButton.${translationKeySuffix}`, [translationKeySuffix]);

    const icon = (
        <Icon
            src={AssetsService.assetUrl(ROCKET_ICON)}
            alt=""
        />
    );

    if (bannerType === ProjectsCtaBannerDict.None) {
        return null;
    }

    return (
        <AddonBanner
            icon={icon}
            dataAutomationId={`projects-cta-banner-${bannerType}`}
            descriptionTranslationKey={bannerDescription}
            bannerCTATranslationKey={bannerCTA}
            onCtaButtonClick={onCtaButtonClick}
            onCloseClicked={onCloseClickWithTracking}
        />
    );
};
